const PREFIX = 'WORKOUT_PROGRAM/';

export const SET_LOCATION = `${PREFIX}SET_LOCATION`;
export const SET_DATE_RANGE = `${PREFIX}SET_DATE_RANGE`;
export const SET_SELECTED_EXERCISE = `${PREFIX}SET_SELECTED_EXERCISE`;
export const GET_WORKOUT_PROGRAM = `${PREFIX}GET_WORKOUT_PROGRAM`;
